import { SessionExpiredError } from './session-error';
import { toastManager } from '@/notifications/toasts';
import * as m from '@/paraglide/messages.js';

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const protectedRequest = path.startsWith('/api/') && !path.startsWith('/api/auth/');
  const response = await fetch(path, init);
  if (protectedRequest && response.status === 401) {
    toastManager.add({
      id: 'session-ended',
      title: m.api_unauthenticated(),
      type: 'error',
      timeout: 0,
      data: { actionHref: '/' },
      actionProps: {
        children: m.auth_sign_in_again(),
      },
    });
    throw new SessionExpiredError(m.api_unauthenticated());
  }
  return response;
}
